const isValidDate = (d: Date): boolean => {
    return d instanceof Date && !isNaN(d.getTime());
};

export const dateFormater = (date?: string | Date): string => {
    if (!date) return "unset";

    const parsedDate = new Date(date);
    if (!isValidDate(parsedDate)) return "unset";

    return parsedDate.toISOString().slice(0, 10);
};
